import _ from 'lodash';

_.templateSettings = {
  evaluate: /\{%([\s\S]+?)%\}/g,
  interpolate: /\{\{([\s\S]+?)\}\}/g,
  escape: /\{\{\{([\s\S]+?)\}\}\}/,
};

export const _templateExecutor = _.template;
